var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.20307V7.42182C0 6.77461 0.524658 6.24995 1.17188 6.24995H18.75V3.9062C18.75 2.86289 20.0146 2.34165 20.7505 3.07754L24.6568 6.98379C25.1144 7.44145 25.1144 8.18344 24.6568 8.64106L20.7505 12.5473C20.0174 13.2803 18.75 12.7664 18.75 11.7187V9.37495H1.17188C0.524658 9.37495 0 8.85029 0 8.20307ZM23.8281 15.6249H6.25V13.2812C6.25 12.2405 4.98721 11.7148 4.24946 12.4525L0.343213 16.3588C-0.114404 16.8165 -0.114404 17.5584 0.343213 18.0161L4.24946 21.9223C4.98325 22.6561 6.25 22.1404 6.25 21.0937V18.7499H23.8281C24.4753 18.7499 25 18.2253 25 17.5781V16.7968C25 16.1496 24.4753 15.6249 23.8281 15.6249Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdt);
export default __webpack_public_path__ + "static/media/tdt.dfa5dcd011be75a97f77c3885d8c123d.svg";
export { ForwardRef as ReactComponent };